import * as React from 'react';
import { useStyles, useTheme } from '@sravni/react-utils';
import modules_3d0bf2ca from '../styles/ContentWidget.module.less.js';

const replaceTokensByValues = (url, tokens) => {
    const { theme = '[theme]' } = tokens;
    return url.replace(/\[theme\]/g, theme);
};
const ContentWidget = React.forwardRef((props, ref) => {
    const { className, url, ...rest } = props;
    const cx = useStyles(modules_3d0bf2ca);
    const [theme] = useTheme();
    const urlWithTokens = replaceTokensByValues(url, { theme });
    return (React.createElement("div", { ref: ref, className: cx('wrapper', className), ...rest },
        React.createElement("iframe", { src: urlWithTokens, width: 570, height: 350, title: "\u0421\u0440\u0430\u0432\u043D\u0438" })));
});

export { ContentWidget };
//# sourceMappingURL=ContentWidget.js.map
